(function () {
  'use strict';

  /* ── State ─────────────────────────────────────────────────── */
  var state = {
    step: 1,
    usageType: null,
    beanStructure: null,
    beans: [
      { beanId: null, ratio: 0 },
      { beanId: null, ratio: 0 },
      { beanId: null, ratio: 0 },
    ],
    roast: null,
    grind: null,
    kg: 5,
    packaging: { p250: 0, p1000: 0, p5000: 0 },
    subscriptionMode: false,
    subFrequency: null,
    subDuration: null,
    subDay: null,
  };

  var config = {};

  /* ── Cart subscription state ───────────────────────────────── */
  // items: { [itemId]: { frequency, duration } }, day: shared preference
  var cartSub = { mode: false, items: {}, day: null };

  /* ── Cart (localStorage) ───────────────────────────────────── */
  var CART_KEY  = 'tkahve_cart';
  var STATE_KEY = 'tkahve_wizard_state';
  function getCart() { try { return JSON.parse(localStorage.getItem(CART_KEY) || '[]'); } catch (e) { return []; } }
  function saveCart(c) { localStorage.setItem(CART_KEY, JSON.stringify(c)); }
  function clearCart() { localStorage.removeItem(CART_KEY); }
  // Sepet, ödeme TAMAMLANINCA temizlenir. Ödemeye yönlenmeden önce sepeti silmek
  // yerine "bekleyen sipariş" işaretle; kullanıcı ödemeden dönerse sepet korunur.
  // Kontrolü (ödendi mi?) cart-drawer.js her sayfa yüklemesinde yapar.
  function markPendingOrder(draftOrderId) {
    if (!draftOrderId) return;
    try {
      localStorage.setItem('tkahve_pending_order', JSON.stringify({ id: String(draftOrderId), at: Date.now() }));
    } catch (e) {}
  }

  /* ── State persistence ─────────────────────────────────────── */
  function saveState() {
    try { localStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  function loadState() {
    try {
      var saved = localStorage.getItem(STATE_KEY);
      if (!saved) return;
      var s = JSON.parse(saved);
      if (s.step)          state.step          = s.step;
      if (s.usageType)     state.usageType     = s.usageType;
      if (s.beanStructure) state.beanStructure = s.beanStructure;
      if (s.beans)         state.beans         = s.beans;
      if (s.roast)         state.roast         = s.roast;
      if (s.grind)         state.grind         = s.grind;
      if (s.kg)            state.kg            = s.kg;
      // Eski kayıtlı state'lerde serbest yazılmış (preset dışı) bir kg değeri
      // olabilir — en yakın preset'e yuvarla, aksi halde +/- butonları ve
      // preset vurgusu bozuk kalır.
      if (KG_PRESETS.indexOf(state.kg) === -1) {
        state.kg = KG_PRESETS.reduce(function (closest, v) {
          return Math.abs(v - state.kg) < Math.abs(closest - state.kg) ? v : closest;
        }, KG_PRESETS[0]);
      }
      // Eski kayıtlı state'lerde p10000 olabilir — 5kg düzenine taşı (10kg
      // paketler düşer; dağılım tutmayınca 6. adım kullanıcıya yeniden dağıttırır).
      if (s.packaging)     state.packaging     = {
        p250:  s.packaging.p250  || 0,
        p1000: s.packaging.p1000 || 0,
        p5000: s.packaging.p5000 || 0,
      };
    } catch (e) {}
  }
  function resetState() {
    state.step = 1; state.usageType = null; state.beanStructure = null;
    state.beans = [{beanId:null,ratio:0},{beanId:null,ratio:0},{beanId:null,ratio:0}];
    state.roast = null; state.grind = null; state.kg = 5;
    state.packaging = { p250: 0, p1000: 0, p5000: 0 };
    state.subscriptionMode = false; state.subFrequency = null; state.subDuration = null; state.subDay = null;
    try { localStorage.removeItem(STATE_KEY); } catch (e) {}
  }

  var TOTAL_STEPS = 7;
  var BLEND_COLORS = ['#5C2E35', '#7FA663', '#4A7A9B'];

  /* ── SVG Icon Library ──────────────────────────────────────── */
  var SVG = {
    /* Usage icons: 52px, stroke-based, uses currentColor */
    filter:
      '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<line x1="9" y1="13" x2="43" y2="13"/>' +
        '<line x1="9" y1="13" x2="26" y2="44"/>' +
        '<line x1="43" y1="13" x2="26" y2="44"/>' +
        '<line x1="26" y1="44" x2="26" y2="49"/>' +
        '<line x1="19" y1="20" x2="26" y2="41"/>' +
        '<line x1="33" y1="20" x2="26" y2="41"/>' +
        '<path d="M17 50 Q26 54 35 50"/>' +
      '</svg>',

    espresso:
      '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M20 12 Q18 9 20 6"/>' +
        '<path d="M26 11 Q24 8 26 5"/>' +
        '<path d="M32 12 Q30 9 32 6"/>' +
        '<path d="M14 22 L18 40 L34 40 L38 22 Z"/>' +
        '<path d="M34 27 Q43 27 43 33 Q43 40 34 40"/>' +
        '<line x1="9" y1="44" x2="43" y2="44"/>' +
      '</svg>',

    turkish:
      '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M18 43 L18 26 Q17 19 22 16 L30 16 Q35 19 34 26 L34 43 Z"/>' +
        '<path d="M13 16 Q17 11 22 11 L30 11 Q35 11 39 16"/>' +
        '<line x1="34" y1="13" x2="41" y2="8"/>' +
        '<path d="M18 31 Q8 31 7 24"/>' +
        '<line x1="16" y1="43" x2="36" y2="43"/>' +
      '</svg>',

    /* Roast beans: 40px, fill-based — same shape, colour darkens per roast level */
    beanLight:
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">' +
        '<g transform="rotate(20 20 20)">' +
          '<ellipse cx="20" cy="20" rx="11" ry="15" fill="#D4A46A"/>' +
          '<path d="M20 6 Q16 20 20 34" stroke="#000" stroke-width="2" stroke-opacity="0.28" fill="none" stroke-linecap="round"/>' +
        '</g>' +
      '</svg>',

    beanMedium:
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">' +
        '<g transform="rotate(20 20 20)">' +
          '<ellipse cx="20" cy="20" rx="11" ry="15" fill="#A0622A"/>' +
          '<path d="M20 6 Q16 20 20 34" stroke="#000" stroke-width="2" stroke-opacity="0.22" fill="none" stroke-linecap="round"/>' +
        '</g>' +
      '</svg>',

    beanFullCity:
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">' +
        '<g transform="rotate(20 20 20)">' +
          '<ellipse cx="20" cy="20" rx="11" ry="15" fill="#5C2C0E"/>' +
          '<path d="M20 6 Q16 20 20 34" stroke="#fff" stroke-width="2" stroke-opacity="0.2" fill="none" stroke-linecap="round"/>' +
        '</g>' +
      '</svg>',

    beanDark:
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">' +
        '<g transform="rotate(20 20 20)">' +
          '<ellipse cx="20" cy="20" rx="11" ry="15" fill="#1E0D05"/>' +
          '<path d="M20 6 Q16 20 20 34" stroke="#fff" stroke-width="2" stroke-opacity="0.3" fill="none" stroke-linecap="round"/>' +
        '</g>' +
      '</svg>',

    /* Grind icons: 28px, currentColor fill — particle size decreases per grind level */
    grindWhole:
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">' +
        '<g transform="rotate(20 14 14)">' +
          '<ellipse cx="14" cy="14" rx="7" ry="10" fill="currentColor"/>' +
          '<path d="M14 5 Q11 14 14 23" stroke="#fff" stroke-width="1.5" stroke-opacity="0.35" fill="none" stroke-linecap="round"/>' +
        '</g>' +
      '</svg>',

    grindCoarse:
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="currentColor">' +
        '<circle cx="8" cy="9" r="4"/>' +
        '<circle cx="20" cy="8" r="4.5"/>' +
        '<circle cx="9" cy="20" r="3.5"/>' +
        '<circle cx="21" cy="20" r="3.5"/>' +
      '</svg>',

    grindMedium:
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="currentColor">' +
        '<circle cx="6" cy="8" r="2.5"/><circle cx="14" cy="6" r="2.5"/><circle cx="22" cy="8" r="2.5"/>' +
        '<circle cx="9" cy="16" r="2.5"/><circle cx="19" cy="15" r="2.5"/>' +
        '<circle cx="5" cy="23" r="2.5"/><circle cx="14" cy="22" r="2.5"/><circle cx="23" cy="22" r="2.5"/>' +
      '</svg>',

    grindFine:
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="currentColor">' +
        '<circle cx="5" cy="7" r="1.3"/><circle cx="11" cy="6" r="1.3"/><circle cx="17" cy="7" r="1.3"/><circle cx="23" cy="7" r="1.3"/>' +
        '<circle cx="7" cy="13" r="1.3"/><circle cx="13" cy="12" r="1.3"/><circle cx="20" cy="13" r="1.3"/><circle cx="25" cy="12" r="1.3"/>' +
        '<circle cx="5" cy="19" r="1.3"/><circle cx="11" cy="18" r="1.3"/><circle cx="17" cy="19" r="1.3"/><circle cx="23" cy="19" r="1.3"/>' +
        '<circle cx="8" cy="24" r="1.3"/><circle cx="15" cy="24" r="1.3"/><circle cx="22" cy="24" r="1.3"/>' +
      '</svg>',
  };

  /* Stable reference to content element — set once in init(), never replaced */
  var contentEl = null;

  /* ── GA4 olayları (huni takibi) ────────────────────────────── */
  /* gtag theme.liquid'de tanımlı; yoksa (reklam engelleyici vb.) sessizce geç. */
  function trackEvent(name, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    } catch (e) {}
  }
  /* Her adım oturumda bir kez raporlanır (ileri-geri gezinme şişirmesin). */
  var trackedSteps = {};
  function trackStep(n) {
    if (trackedSteps[n]) return;
    trackedSteps[n] = true;
    trackEvent('wizard_step', { step_number: n });
  }

  /* ── Boot ──────────────────────────────────────────────────── */
  var PRICING_CONFIG_URL = 'https://toptankahve-checkout.vercel.app/api/pricing-config';

  var PRICE_RETRY_DELAYS = [1000, 3000, 8000, 15000];

  function applyServerPricing(attempt) {
    attempt = attempt || 0;
    fetch(PRICING_CONFIG_URL)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        // Sunucudan çekirdek başına HAZIR satış fiyatları (TL/kg) gelir;
        // ham maliyet/kur/çarpan istemciye hiç inmez.
        if (!d || !d.prices) throw new Error('fiyat yanıtı boş');
        config.serverPrices = d.prices;
        config.qtyTiers     = d.qtyTiers || null;
        config.outOfStock   = d.outOfStock || [];
        hidePriceWarning();
        // Kayıtlı state ile kullanıcı doğrudan çekirdek adımına dönebildiği için
        // fiyatlar render'dan sonra gelirse mevcut adım yeniden çizilmeli;
        // yoksa kartlar fiyatsız kalır. Kullanıcı bir alana yazıyorsa çizme
        // (odak kaybolur) — sonraki adım geçişi zaten güncel fiyatla çizer.
        try {
          var ae = document.activeElement;
          var typing = ae && contentEl && contentEl.contains(ae) &&
            /^(INPUT|SELECT|TEXTAREA)$/.test(ae.tagName);
          if (!typing) renderStep(state.step);
          updateAside();
        } catch (e) {}
        if (typeof updatePriceSection === 'function') { try { updatePriceSection(); } catch (e) {} }
      })
      .catch(function () {
        if (attempt < PRICE_RETRY_DELAYS.length) {
          setTimeout(function () { applyServerPricing(attempt + 1); }, PRICE_RETRY_DELAYS[attempt]);
        } else {
          showPriceWarning();
        }
      });
  }

  /* Fiyatlar yüklenemediğinde müşteriye "0 TL" yerine açıklama göster.
     Sipariş fiyatı her durumda sunucuda hesaplandığı için sipariş verilebilir
     kalır; yalnızca gösterim etkilenir. */
  function showPriceWarning() {
    if (document.getElementById('wizard-price-warning')) return;
    var w = document.getElementById('order-wizard');
    if (!w) return;
    var div = document.createElement('div');
    div.id = 'wizard-price-warning';
    div.className = 'wizard-price-warning';
    div.innerHTML = 'Güncel fiyatlar yüklenemedi. ' +
      '<button type="button" id="wizard-price-retry">Tekrar dene</button>';
    w.insertBefore(div, w.firstChild);
    var btn = document.getElementById('wizard-price-retry');
    if (btn) btn.addEventListener('click', function () {
      btn.disabled = true; btn.textContent = 'Deneniyor…';
      hidePriceWarning();
      applyServerPricing(0);
    });
  }

  function hidePriceWarning() {
    var el = document.getElementById('wizard-price-warning');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function init() {
    var configEl = document.getElementById('order-wizard-config');
    if (!configEl) { showInitError('order-wizard-config elementi bulunamadi.'); return; }
    try { config = JSON.parse(configEl.textContent); }
    catch (e) { showInitError('JSON parse hatasi: ' + e.message); return; }

    // Fiyat parametrelerini sunucudan (tek kaynak) çek ve gömülü varsayılanların
    // üzerine yaz — böylece gösterilen fiyat, siparişte kesilecek fiyatla aynı olur.
    // Ulaşılamazsa gömülü varsayılanlarla devam edilir (yalnızca gösterim etkilenir).
    applyServerPricing();

    loadState();

    var prevBtn = document.getElementById('wizard-prev');
    var nextBtn = document.getElementById('wizard-next');
    contentEl   = document.getElementById('wizard-step-content');
    if (!prevBtn || !nextBtn || !contentEl) { showInitError('Wizard elementleri bulunamadi.'); return; }

    prevBtn.addEventListener('click', prevStep);
    nextBtn.addEventListener('click', handleNext);
    var asideBtn = document.getElementById('wizard-aside-add');
    if (asideBtn) asideBtn.addEventListener('click', addToLocalCart);
    var asideEl = document.querySelector('.wizard-aside');
    if (asideEl) asideEl.addEventListener('click', onAsideClick);

    /* ── Step nav: click on completed steps to go back ── */
    var stepsNav = document.querySelector('.wizard-steps-nav');
    if (stepsNav) {
      stepsNav.addEventListener('click', function (e) {
        var btn = e.target.closest('.wizard-step-btn');
        if (!btn) return;
        var n = parseInt(btn.dataset.step);
        if (n < state.step) { state.step = n; go(); }
      });
    }

    /* ── Event delegation: bound ONCE to the stable contentEl ── */
    contentEl.addEventListener('click',  onContentClick);
    contentEl.addEventListener('change', onContentChange);

    renderStep(state.step);
    updateProgress();
    updateAside();
  }

  function showInitError(msg) {
    var el = document.getElementById('wizard-step-content');
    if (el) el.innerHTML = '<p style="color:#c62828;padding:1rem;border:1px solid #f44336;border-radius:8px;background:#fdf1f1">Hata: ' + msg + '</p>';
  }

  function handleNext() {
    if (state.step === TOTAL_STEPS) {
      if (state.subscriptionMode) {
        createSubscriptionFromWizard();
      } else {
        addToLocalCart();
      }
    } else {
      nextStep();
    }
  }
  function nextStep()   { if (canProceed()) { state.step++; go(); } }
  function prevStep()   { if (state.step > 1) { state.step--; go(); } }

  function go() {
    renderStep(state.step);
    updateProgress();
    updateAside();
    saveState();
    var w = document.getElementById('order-wizard');
    if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Progress ──────────────────────────────────────────────── */
  function updateProgress() {
    var bar = document.getElementById('wizard-progress-bar');
    if (bar) bar.style.width = ((state.step / TOTAL_STEPS) * 100) + '%';

    document.querySelectorAll('.wizard-step-btn').forEach(function (btn) {
      var n = parseInt(btn.dataset.step);
      btn.classList.toggle('is-done',   n < state.step);
      btn.classList.toggle('is-active', n === state.step);
      btn.classList.toggle('is-future', n > state.step);
    });

    var prev = document.getElementById('wizard-prev');
    var next = document.getElementById('wizard-next');
    if (prev) prev.style.visibility = state.step === 1 ? 'hidden' : 'visible';
    if (next) {
      if (state.step === TOTAL_STEPS) {
        next.textContent = state.subscriptionMode ? 'Abonelik \u00d6demesine Ge\u00e7' : 'Sepete Ekle';
      } else {
        next.textContent = '\u0130leri \u2192';
      }
    }
  }

  /* ── Validation ────────────────────────────────────────────── */
  function canProceed() {
    clearError();
    switch (state.step) {
      case 1:
        if (!state.usageType)     { showError('L\u00fctfen bir kullan\u0131m alan\u0131 se\u00e7in.'); return false; }
        return true;
      case 2:
        if (!state.beanStructure) { showError('L\u00fctfen \u00e7ekirdek yap\u0131s\u0131n\u0131 se\u00e7in.'); return false; }
        return true;
      case 3: return validateBeans();
      case 4:
        if (!state.roast) { showError('L\u00fctfen kavurma derecesini se\u00e7in.'); return false; }
        if (!state.grind) { showError('L\u00fctfen \u00f6\u011f\u00fctme tercihini se\u00e7in.'); return false; }
        return true;
      case 5:
        if (state.kg < 5)   { showError('Minimum sipari\u015f miktar\u0131 5 kg\u2019d\u0131r.'); return false; }
        if (state.kg > 200) { showError('200 kg \u00fczeri sipari\u015fler i\u00e7in l\u00fctfen bizi aray\u0131n.'); return false; }
        return true;
      case 6: return validatePackaging();
      default: return true;
    }
  }

  function validateBeans() {
    var selected = selectedBeans();
    if (state.beanStructure === 'single') {
      if (!selected[0]) { showError('\u00c7ekirdek se\u00e7imi yap\u0131n.'); return false; }
      return true;
    }
    // blend
    if (selected.length < 2) { showError('En az 2 \u00e7ekirdek se\u00e7in.'); return false; }
    var total = selected.reduce(function (s, b) { return s + (parseInt(b.ratio) || 0); }, 0);
    if (total !== 100) { showError('Blend oranlar\u0131 toplam\u0131 %100 olmal\u0131. \u015eu an: %' + total); return false; }
    return true;
  }

  function validatePackaging() {
    var total = packagingKg();
    if (Math.abs(total - state.kg) > 0.001) {
      showError('Ambalaj da\u011f\u0131l\u0131m\u0131 toplam\u0131 ' + state.kg + ' kg olmal\u0131. \u015eu an: ' + total.toFixed(2) + ' kg');
      return false;
    }
    return true;
  }

  function selectedBeans() {
    return state.beans.filter(function (b) { return b.beanId !== null; });
  }

  /* 5 kg ambalaja konan kilolara uygulanan indirim oranı.
     GERÇEK indirim sunucuda (create-order) ambalaj adetlerinden yeniden
     hesaplanır — buradaki değer yalnızca gösterim içindir. */
  var PKG5_DISCOUNT = 0.02;

  /* Miktar kademeleri: sunucudan gelir (pricing-config), gelmezse bu
     varsayılanlar kullanılır. Sunucudaki DEFAULT_QTY_TIERS ile aynı tutulur. */
  var DEFAULT_QTY_TIERS = [
    { minKg: 200, multiplier: 0.88 },
    { minKg: 0,   multiplier: 1.00 },
  ];

  function qtyTierMultiplier(kg) {
    var tiers = (config.qtyTiers && config.qtyTiers.length) ? config.qtyTiers : DEFAULT_QTY_TIERS;
    var k = Number(kg);
    if (!(k > 0)) return 1;
    /* En yüksek eşikten aşağı in: ilk uyan kademe geçerli */
    var sorted = tiers.slice().sort(function (a, b) { return Number(b.minKg) - Number(a.minKg); });
    for (var i = 0; i < sorted.length; i++) {
      if (k >= Number(sorted[i].minKg)) return Number(sorted[i].multiplier);
    }
    return 1;
  }

  function packagingKg() {
    return (state.packaging.p250 * 0.25) + (state.packaging.p1000 * 1) + (state.packaging.p5000 * 5);
  }

  /* 5 kg paketlere konan toplam kilo (indirime tabi kısım). */
  function fiveKgKilos() {
    return Math.min(state.packaging.p5000 * 5, state.kg);
  }

  function showError(msg) {
    var el = document.getElementById('wizard-errors');
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }
  function clearError() {
    var el = document.getElementById('wizard-errors');
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  }

  /* ── Price ─────────────────────────────────────────────────── */

  /* Satış fiyatları sunucudan hazır gelir (TL/kg) — ham maliyet istemcide yok.
     tier: 'oneTime' | 'sub3' | 'sub6' */
  function serverBeanPrice(beanId, tier) {
    var tables = config.serverPrices || {};
    var table  = tables[tier || 'oneTime'] || {};
    return parseFloat(table[beanId]) || 0;
  }

  function calcBeanSalePrice(bean) {
    return serverBeanPrice(bean.id, 'oneTime');
  }

  /* Admin panelde "Stok dışı" işaretlenen çekirdekler (pricing-config API). */
  function isBeanOOS(beanId) {
    return (config.outOfStock || []).indexOf(beanId) !== -1;
  }

  /* Kart etiketi: fiyatlar henüz/hiç yüklenmediyse "0 TL/kg" yerine "—". */
  function beanPriceLabel(bean) {
    if (isBeanOOS(bean.id)) return 'Stok dışı';
    var p = calcBeanSalePrice(bean);
    return p > 0 ? Math.round(p) + ' TL/kg' : '—';
  }

  /* Seçili harmanın abonelik fiyatı (TL/kg) — süreye göre sunucu tablosundan */
  function calcSubPerKg(months) {
    var sel = selectedBeans();
    if (!sel.length) return 0;
    // Tek köken seçiminde ratio 0 kalır (calculatePrice'taki özel durumun
    // aynısı): oran ağırlıklandırması yapmadan çekirdeğin fiyatı kullanılır.
    /* Miktar kademesi abonelikte de teslimat başına kiloya göre uygulanır */
    var tierMult = qtyTierMultiplier(state.kg);
    if (state.beanStructure === 'single') {
      var p = serverBeanPrice(sel[0].beanId, 'sub' + months) || 0;
      return Math.round(p * tierMult * 100) / 100;
    }
    var valid = sel.filter(function (b) { return b.beanId && serverBeanPrice(b.beanId, 'sub' + months) > 0; });
    if (!valid.length) return 0;
    var ratioTotal = valid.reduce(function (s, b) { return s + (parseInt(b.ratio) || 0); }, 0);
    if (!ratioTotal) return 0;
    var perKgTL = 0;
    for (var i = 0; i < valid.length; i++) {
      var b = valid[i];
      perKgTL += serverBeanPrice(b.beanId, 'sub' + months) * ((parseInt(b.ratio) || 0) / ratioTotal);
    }
    return Math.round(perKgTL * tierMult * 100) / 100;
  }

  function calculatePrice() {
    var sel = selectedBeans();
    if (!sel.length) return null;
    var perKg;
    if (state.beanStructure === 'single') {
      var bean = findBean(sel[0].beanId);
      if (!bean) return null;
      perKg = calcBeanSalePrice(bean);
    } else {
      /* Weighted average of each bean's sale price */
      var ratioTotal = sel.reduce(function (s, b) { return s + (parseInt(b.ratio) || 0); }, 0);
      if (ratioTotal === 0) return null;
      perKg = sel.reduce(function (sum, b) {
        var beanObj = findBean(b.beanId);
        if (!beanObj) return sum;
        return sum + calcBeanSalePrice(beanObj) * ((parseInt(b.ratio) || 0) / 100);
      }, 0);
    }
    if (!perKg) return null;
    /* Önce miktar kademesi, sonra 5 kg ambalaj indirimi (sunucuyla aynı sıra) */
    var tierMult = qtyTierMultiplier(state.kg);
    var effPerKg = perKg * tierMult;
    var discount = effPerKg * fiveKgKilos() * PKG5_DISCOUNT;
    return {
      perKg: effPerKg,
      basePerKg: perKg,
      tierPct: Math.round((1 - tierMult) * 100),
      tierSave: (perKg - effPerKg) * state.kg,
      discount: discount,
      total: effPerKg * state.kg - discount,
    };
  }

  /* ── Aside ─────────────────────────────────────────────────── */
  function canAddToCart() {
    if (!state.usageType || !state.beanStructure) return false;
    var sel = selectedBeans();
    if (state.beanStructure === 'single') { if (!sel[0]) return false; }
    else {
      if (sel.length < 2) return false;
      var t = sel.reduce(function (s, b) { return s + (parseInt(b.ratio) || 0); }, 0);
      if (t !== 100) return false;
    }
    if (!state.roast || !state.grind) return false;
    if (state.kg < 5 || state.kg > 200) return false;
    var pkg = packagingKg();
    if (pkg === 0 || Math.abs(pkg - state.kg) > 0.001) return false;
    return true;
  }

  function updateAside() {
    updateSummaryRows();
    updatePriceSection();
    updateAsideButton();
    updateCartSection();
  }

  function updateSummaryRows() {
    var el = document.getElementById('wizard-summary-rows');
    if (!el) return;
    var beanText = getBeanSummaryText();
    var rows = [
      { label: 'T\u00fcr',     value: usageLabel()     },
      { label: 'Karakter', value: structureLabel() },
      { label: '\u00c7ekirdek', value: beanText         },
      { label: 'Kavurma',  value: roastLabel()     },
      { label: '\u00d6\u011f\u00fctme',   value: grindLabel()     },
      { label: 'Miktar',   value: state.usageType ? state.kg + ' kg' : '' },
      { label: 'Ambalaj',  value: packagingSummaryText() },
    ];
    el.innerHTML = rows.map(function (r) {
      var val = r.value
        ? '<span class="summary-row__value">' + r.value + '</span>'
        : '<span class="summary-row__empty">\u2014</span>';
      return '<div class="summary-row"><span class="summary-row__label">' + r.label + '</span>' + val + '</div>';
    }).join('');
  }

  function updatePriceSection() {
    var el = document.getElementById('wizard-price-panel');
    if (!el) return;
    var r = calculatePrice();
    if (!r) { el.innerHTML = '<p class="price-panel__hint">Se\u00e7imlerinizi yap\u0131nca tahmini fiyat burada g\u00f6r\u00fcn\u00fcr.</p>'; return; }
    el.innerHTML =
      '<div class="price-panel__perkg">' + formatMoney(r.perKg) + ' / kg</div>' +
      (r.tierPct > 0 ? '<div class="price-panel__discount"><span>Miktar indirimi (%' + r.tierPct + ')</span><strong>−' + formatMoney(r.tierSave) + '</strong></div>' : '') +
      (r.discount > 0 ? '<div class="price-panel__discount"><span>5 kg ambalaj indirimi (%2)</span><strong>−' + formatMoney(r.discount) + '</strong></div>' : '') +
      '<div class="price-panel__total"><span>Tahmini Toplam</span><strong>' + formatMoney(r.total) + '</strong></div>' +
      '<p class="price-panel__note">Tahmini fiyatt\u0131r, onaydan sonra kesinle\u015fir.</p>';
  }

  function updateAsideButton() {
    var btn  = document.getElementById('wizard-aside-add');
    var note = document.getElementById('wizard-aside-add-note');
    if (!btn) return;
    var ready = canAddToCart();
    btn.disabled = !ready;
    if (note) note.style.display = ready ? 'none' : 'block';
  }

  /* ── Labels ────────────────────────────────────────────────── */
  function usageLabel()    { return { turkish: 'T\u00fcrk Kahvesi', filter: 'Filtre Kahve', espresso: 'Espresso' }[state.usageType] || ''; }
  function roastLabel()    { return { light: 'Light', medium: 'Medium', 'full-city': 'Full City', dark: 'Dark' }[state.roast] || ''; }
  function grindLabel() {
    if (!state.grind) return '';
    if (state.grind === 'fine' && state.usageType === 'turkish') return '\u00d6\u011f\u00fct\u00fclm\u00fc\u015f';
    return { whole: '\u00c7ekirdek', coarse: 'Kal\u0131n \u00d6\u011f.', medium: 'Orta \u00d6\u011f.', fine: '\u0130nce \u00d6\u011f.' }[state.grind] || '';
  }
  function structureLabel(){ return { single: 'Single Origin', blend: '\u00d6zel Blend' }[state.beanStructure] || ''; }

  function getBeanSummaryText() {
    var sel = selectedBeans();
    if (!sel.length) return '';
    return sel.map(function (b) {
      var bean = findBean(b.beanId);
      return bean ? bean.name + (state.beanStructure === 'blend' ? ' %' + b.ratio : '') : '';
    }).join(', ');
  }

  function packagingSummaryText() {
    var parts = [];
    if (state.packaging.p250)  parts.push(state.packaging.p250  + 'x 250g');
    if (state.packaging.p1000) parts.push(state.packaging.p1000 + 'x 1kg');
    if (state.packaging.p5000) parts.push(state.packaging.p5000 + 'x 5kg');
    return parts.join(', ');
  }

  function findBean(id) { return (config.beans || []).find(function (b) { return b.id === id; }); }
  function formatMoney(n) { return n.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' TL'; }

  function countryCodeToFlag(code) {
    if (!code || code.length !== 2) return '';
    return Array.from(code.toUpperCase()).map(function (c) {
      return String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65);
    }).join('');
  }

  /* ── Bean toggle helpers ───────────────────────────────────── */
  function toggleBlendBean(beanId) {
    var existingIdx = -1;
    for (var i = 0; i < 3; i++) { if (state.beans[i].beanId === beanId) { existingIdx = i; break; } }

    if (existingIdx !== -1) {
      state.beans[existingIdx].beanId = null;
      state.beans[existingIdx].ratio  = 0;
      // Compact
      var filled = state.beans.filter(function (b) { return b.beanId !== null; });
      state.beans[0] = filled[0] || { beanId: null, ratio: 0 };
      state.beans[1] = filled[1] || { beanId: null, ratio: 0 };
      state.beans[2] = filled[2] || { beanId: null, ratio: 0 };
    } else {
      var cnt = selectedBeans().length;
      if (cnt >= 3) return;
      for (var j = 0; j < 3; j++) {
        if (!state.beans[j].beanId) { state.beans[j].beanId = beanId; break; }
      }
    }
    rebalanceRatios();
  }

  function rebalanceRatios() {
    var indices = [];
    for (var i = 0; i < 3; i++) { if (state.beans[i].beanId) indices.push(i); }
    if (indices.length === 1) { state.beans[indices[0]].ratio = 100; }
    else if (indices.length === 2) { state.beans[indices[0]].ratio = 60; state.beans[indices[1]].ratio = 40; }
    else if (indices.length === 3) { state.beans[indices[0]].ratio = 50; state.beans[indices[1]].ratio = 30; state.beans[indices[2]].ratio = 20; }
  }

  /* ── Renderers ─────────────────────────────────────────────── */
  function renderStep(n) {
    /* Only update innerHTML — do NOT re-bind events here.
       Event listeners live on contentEl and are bound once in init(). */
    var renders = [null, step1, step2, step3, step4, step5, step6, step7];
    contentEl.innerHTML = renders[n]();
    clearError();
    trackStep(n);
  }

  /* Step 1 */
  function step1() {
    var types = [
      { id: 'filter',   icon: SVG.filter,   title: 'Filtre Kahve',  desc: 'Drip, V60, Chemex, batch brew ve benzeri filtre demleme y\u00f6ntemleri' },
      { id: 'espresso', icon: SVG.espresso, title: 'Espresso',     desc: 'Espresso makineleri, otomatik barista sistemleri ve kaps\u00fcl \u00fcreticiler' },
      { id: 'turkish',  icon: SVG.turkish,  title: 'T\u00fcrk Kahvesi', desc: 'Geleneksel cezve, otomatik T\u00fcrk kahvesi makineleri' },
    ];
    return '<div class="wizard-step">' +
      '<h2 class="wizard-step__title">Kullan\u0131m Alan\u0131n\u0131 Se\u00e7in</h2>' +
      '<p class="wizard-step__desc">Kahvenizi hangi demleme y\u00f6ntemi i\u00e7in kullanacaks\u0131n\u0131z?</p>' +
      '<div class="choice-cards">' +
        types.map(function (t) {
          return '<button class="choice-card' + (state.usageType === t.id ? ' is-selected' : '') + '" data-action="usage" data-value="' + t.id + '" type="button">' +
            '<span class="choice-card__icon">' + t.icon + '</span>' +
            '<span class="choice-card__title">' + t.title + '</span>' +
            '<span class="choice-card__desc">'  + t.desc  + '</span>' +
          '</button>';
        }).join('') +
      '</div>' +
    '</div>';
  }

  /* Step 2 */
  function step2() {
    var types = [
      { id: 'single', title: 'Single Origin', desc: 'Tek bir b\u00f6lgeden, o b\u00f6lgeye \u00f6zg\u00fc tatlar. Saf ve tan\u0131mlay\u0131c\u0131 bir kahve deneyimi.' },
      { id: 'blend',  title: '\u00d6zel Blend',    desc: '2 veya 3 farkl\u0131 \u00e7ekirdek se\u00e7in, oranlar\u0131n\u0131 belirleyin. Kendi \u00f6zel blendinizi olu\u015fturun.' },
    ];

    var recipeHtml = '';
    if (state.usageType) {
      var recipes = (config.recipes || []).filter(function (r) { return r.usageType === state.usageType; });
      if (recipes.length) {
        var roastMap = { light: 'Light', medium: 'Medium', 'full-city': 'Full City', dark: 'Dark' };
        recipeHtml =
          '<div class="recipe-section">' +
            '<div class="recipe-divider">Haz\u0131r Re\u00e7eteler ile H\u0131zl\u0131 Sipari\u015f</div>' +
            '<div class="recipe-cards">' +
              recipes.map(function (r) {
                var beanNames = r.beans.map(function (b) {
                  var bean = findBean(b.beanId);
                  return (bean ? bean.name : b.beanId) + (r.beans.length > 1 ? ' %' + b.ratio : '');
                }).join(' + ');
                return '<button class="recipe-card" data-action="recipe-select" data-recipe-id="' + r.id + '" type="button">' +
                  '<span class="recipe-card__name">' + r.name + '</span>' +
                  '<span class="recipe-card__roast">\u00d6nerilen: ' + (roastMap[r.roast] || r.roast) + '</span>' +
                  '<span class="recipe-card__beans">' + beanNames + '</span>' +
                '</button>';
              }).join('') +
            '</div>' +
          '</div>';
      }
    }

    return '<div class="wizard-step">' +
      '<h2 class="wizard-step__title">\u00c7ekirdek Yap\u0131s\u0131n\u0131 Se\u00e7in</h2>' +
      '<p class="wizard-step__desc">Nas\u0131l bir \u00e7ekirdek kompozisyonu istiyorsunuz?</p>' +
      '<div class="choice-cards choice-cards--2col">' +
        types.map(function (t) {
          return '<button class="choice-card' + (state.beanStructure === t.id ? ' is-selected' : '') + '" data-action="structure" data-value="' + t.id + '" type="button">' +
            '<span class="choice-card__title">' + t.title + '</span>' +
            '<span class="choice-card__desc">'  + t.desc  + '</span>' +
          '</button>';
        }).join('') +
      '</div>' +
      recipeHtml +
    '</div>';
  }

  /* Step 3 */
  function step3() {
    return state.beanStructure === 'single' ? step3Single() : step3Blend();
  }

  function beanCardHtml(bean, isSelected, colorIndex, action) {
    var cc    = (bean.countryCode || '').toLowerCase();
    var color = isSelected && colorIndex >= 0 ? BLEND_COLORS[colorIndex] : null;
    var selClass   = isSelected ? ' is-selected' : '';
    var colorStyle = color ? ' style="--sel-color:' + color + '"' : '';

    var titleHtml = bean.name;

    var chipsHtml = '';
    if (bean.flavorNotes && bean.flavorNotes.length) {
      chipsHtml = '<div class="bcf__chips">' + bean.flavorNotes.map(function (n) {
        return '<span class="bcf__chip">' + n + '</span>';
      }).join('') + '</div>';
    }

    var metaHtml = '<div class="bcf__meta">' +
      '<div class="bcf__meta-row"><span class="bcf__meta-label">\u0130\u015flem</span><span class="bcf__meta-val">' + (bean.process || '\u2014') + '</span></div>' +
      '<div class="bcf__meta-row"><span class="bcf__meta-label">Rak\u0131m</span><span class="bcf__meta-val">' + (bean.altitude || '\u2014') + '</span></div>' +
      '<div class="bcf__meta-row"><span class="bcf__meta-label">T\u00fcr</span><span class="bcf__meta-val">' + (bean.species || 'Arabica') + '</span></div>' +
    '</div>';

    var checkHtml = isSelected
      ? '<span class="bcf__check"' + (color ? ' style="background:' + color + '"' : '') + '>\u2713</span>'
      : '';

    var flagHtml = '';
    if (cc) {
      flagHtml = '<div class="bcf__flag-area">' +
        '<img class="bcf__flag-img" src="https://flagcdn.com/w320/' + cc + '.png" alt="' + (bean.country || '') + ' bayra\u011f\u0131" loading="eager">' +
        '<svg class="bcf__wave" viewBox="0 0 200 32" preserveAspectRatio="none"><path d="M0,32 C55,6 145,28 200,10 L200,32 Z" fill="#fff"/></svg>' +
      '</div>';
    }

    var hintSvg = '<svg class="bcf__hint-icon" width="9" height="9" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="4.3" stroke="currentColor" stroke-width="1.2"/><rect x="4.4" y="4.4" width="1.2" height="3.1" rx="0.6" fill="currentColor"/><circle cx="5" cy="3.05" r="0.65" fill="currentColor"/></svg>';

    var selLabel  = isSelected ? 'Se\u00e7ildi \u2713' : 'Se\u00e7';
    var selActCls = isSelected ? ' bcf__mob-sel--act' : '';

    var mobFrontBtns = '<div class="bcf__mob-btns">' +
      '<button class="bcf__mob-sel' + selActCls + '" data-action="' + action + '" data-bean-id="' + bean.id + '" type="button">' + selLabel + '</button>' +
      '<button class="bcf__mob-detail" data-action="bean-detail" data-bean-id="' + bean.id + '" type="button">Detay \u2192</button>' +
    '</div>';

    var mobBackBtns = '<div class="bcf__mob-btns bcf__mob-btns--back">' +
      '<button class="bcf__mob-sel bcf__mob-sel--back' + selActCls + '" data-action="' + action + '" data-bean-id="' + bean.id + '" type="button">' + selLabel + '</button>' +
      '<button class="bcf__mob-back" data-action="bean-detail" data-bean-id="' + bean.id + '" type="button">\u2190 Geri</button>' +
    '</div>';

    var oosClass = isBeanOOS(bean.id) ? ' bcf--oos' : '';
    return '<div class="bcf' + selClass + oosClass + '"' + colorStyle +
      ' data-action="' + action + '" data-bean-id="' + bean.id + '" role="button" tabindex="0">' +
      checkHtml +
      '<div class="bcf__inner">' +
        '<div class="bcf__front">' +
          flagHtml +
          '<div class="bcf__info">' +
            '<div><div class="bcf__name">' + bean.name + '</div>' +
            '<div class="bcf__region">' + (bean.region || '') + (bean.country ? ', ' + bean.country : '') + '</div></div>' +
            '<div class="bcf__footer">' +
              '<span class="bcf__price">' + beanPriceLabel(bean) + '</span>' +
              '<span class="bcf__hint">' + hintSvg + ' detay</span>' +
            '</div>' +
            mobFrontBtns +
          '</div>' +
        '</div>' +
        '<div class="bcf__back" data-action="' + action + '" data-bean-id="' + bean.id + '">' +
          '<div class="bcf__back-title">' + titleHtml + '</div>' +
          chipsHtml +
          metaHtml +
          mobBackBtns +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function step3Single() {
    var beans = config.beans || [];
    var selId = state.beans[0].beanId;
    return '<div class="wizard-step">' +
      '<h2 class="wizard-step__title">\u00c7ekirdek Se\u00e7in</h2>' +
      '<p class="wizard-step__desc">Tek bir k\u00f6kenden \u00e7ekirdek se\u00e7in.</p>' +
      '<div class="bean-cards">' +
        beans.map(function (b) {
          return beanCardHtml(b, b.id === selId, -1, 'bean-select-single');
        }).join('') +
      '</div>' +
    '</div>';
  }

  function step3Blend() {
    var beans    = config.beans || [];
    var sel      = selectedBeans();
    var selIds   = sel.map(function (b) { return b.beanId; });

    var cardsHtml = '<div class="bean-cards">' +
      beans.map(function (b) {
        var idx = selIds.indexOf(b.id);
        return beanCardHtml(b, idx !== -1, idx, 'bean-toggle-blend');
      }).join('') +
    '</div>';

    var ratioHtml = '';
    if (sel.length >= 2) {
      var total = sel.reduce(function (s, b) { return s + (parseInt(b.ratio) || 0); }, 0);
      var segments = sel.map(function (b, i) {
        return '<div class="ratio-bar__segment" style="width:' + Math.max(0, parseInt(b.ratio) || 0) + '%;background:' + BLEND_COLORS[i] + '"></div>';
      }).join('');
      var okClass = total === 100 ? 'ratio-total-display--ok' : total > 100 ? 'ratio-total-display--over' : '';
      var okText  = total === 100 ? 'Toplam: %100 \u2713' : total > 100 ? 'Toplam: %' + total + ' \u2014 fazla' : 'Toplam: %' + total + ' \u2014 ' + (100 - total) + '% kalan';

      var rows = sel.map(function (b, i) {
        var bean = findBean(b.beanId);
        var flag = bean ? countryCodeToFlag(bean.countryCode || '') : '';
        return '<div class="ratio-row">' +
          '<span class="ratio-row__dot" style="background:' + BLEND_COLORS[i] + '"></span>' +
          (flag ? '<span class="ratio-row__flag">' + flag + '</span>' : '') +
          '<span class="ratio-row__name">' + (bean ? bean.name : '') + '</span>' +
          '<div class="ratio-stepper">' +
            '<button type="button" class="ratio-stepper__btn" data-action="ratio-minus" data-index="' + i + '" aria-label="Oranı 10 azalt">−</button>' +
            '<span class="ratio-stepper__val">%' + (parseInt(b.ratio) || 0) + '</span>' +
            '<button type="button" class="ratio-stepper__btn" data-action="ratio-plus" data-index="' + i + '" aria-label="Oranı 10 artır">+</button>' +
          '</div>' +
        '</div>';
      }).join('');

      ratioHtml = '<div class="blend-ratio-section">' +
        '<p class="blend-ratio-section__title">Blend Oran Da\u011f\u0131l\u0131m\u0131</p>' +
        '<div class="ratio-bar">' + segments + '</div>' +
        '<div class="ratio-total-display ' + okClass + '">' + okText + '</div>' +
        rows +
      '</div>';
    } else {
      ratioHtml = '<div class="blend-hint">2 veya 3 \u00e7ekirdek se\u00e7in, ard\u0131ndan oranlar\u0131 belirleyin.</div>';
    }

    return '<div class="wizard-step">' +
      '<h2 class="wizard-step__title">Blend \u00c7ekirdeklerinizi Se\u00e7in</h2>' +
      '<p class="wizard-step__desc">2 veya 3 \u00e7ekirdek se\u00e7in (se\u00e7ili karta tekrar t\u0131klay\u0131nca \u00e7\u0131kar\u0131r\u0131n\u0131z).</p>' +
      cardsHtml +
      ratioHtml +
    '</div>';
  }

  /* Step 4 */
  function step4() {
    var roastOpts = [
      { id: 'light',     icon: SVG.beanLight,    label: 'Light',     desc: 'Meyvemsi, asitli, \u00e7i\u00e7e\u011fi a\u00e7mam\u0131\u015f aromalar. Filtre i\u00e7in ideal.' },
      { id: 'medium',    icon: SVG.beanMedium,   label: 'Medium',    desc: 'Dengeli, karamelli tatl\u0131l\u0131k, orta asidite. En \u00e7ok tercih edilen.' },
      { id: 'full-city', icon: SVG.beanFullCity, label: 'Full City', desc: 'Koyu karamel, \u00e7i\u00e7eklenmeye ba\u015flayan ya\u011f. Espresso-filtre aras\u0131.' },
      { id: 'dark',      icon: SVG.beanDark,     label: 'Dark',      desc: 'Koyu, dumans\u0131 g\u00f6vde. T\u00fcrk kahvesi ve espresso i\u00e7in.' },
    ];
    var grindByType = {
      espresso: [
        { id: 'whole', icon: SVG.grindWhole, label: '\u00c7ekirdek', desc: 'Espresso makineniz \u00e7ekirdekleri kendi \u00f6\u011f\u00fcter. Ham \u00e7ekirdek g\u00f6ndeririz.' },
      ],
      turkish: [
        { id: 'whole', icon: SVG.grindWhole, label: '\u00c7ekirdek',       desc: 'Kavrulmu\u015f, \u00f6\u011f\u00fct\u00fclmemi\u015f. Kendi ekipman\u0131n\u0131zla \u00f6\u011f\u00fctin.' },
        { id: 'fine',  icon: SVG.grindFine,  label: '\u00d6\u011f\u00fct\u00fclm\u00fc\u015f', desc: 'T\u00fcrk kahvesi i\u00e7in \u00f6zel ince \u00f6\u011f\u00fctme.' },
      ],
      filter: [
        { id: 'whole',  icon: SVG.grindWhole,  label: '\u00c7ekirdek',                desc: 'Kavrulmu\u015f, \u00f6\u011f\u00fct\u00fclmemi\u015f. Kendi ekipman\u0131n\u0131zla \u00f6\u011f\u00fctin.' },
        { id: 'coarse', icon: SVG.grindCoarse, label: 'Kal\u0131n \u00d6\u011f\u00fct\u00fclm\u00fc\u015f', desc: 'French press, perkolat\u00f6r i\u00e7in.' },
        { id: 'medium', icon: SVG.grindMedium, label: 'Orta \u00d6\u011f\u00fct\u00fclm\u00fc\u015f',  desc: 'Pour over, filtre makinesi, chemex i\u00e7in.' },
        { id: 'fine',   icon: SVG.grindFine,   label: '\u0130nce \u00d6\u011f\u00fct\u00fclm\u00fc\u015f',  desc: 'Moka pot, aeropress i\u00e7in.' },
      ],
    };
    var grindOpts = grindByType[state.usageType] || grindByType.filter;

    function btn(item, action, current, cardClass) {
      return '<button class="choice-card ' + cardClass + (current === item.id ? ' is-selected' : '') + '" data-action="' + action + '" data-value="' + item.id + '" type="button">' +
        '<span class="choice-card__icon">' + item.icon + '</span>' +
        '<span class="choice-card__title">' + item.label + '</span>' +
        '<span class="choice-card__desc">'  + item.desc  + '</span>' +
      '</button>';
    }

    return '<div class="wizard-step">' +
      '<h2 class="wizard-step__title">Kavurma ve \u00d6\u011f\u00fctme Tercihi</h2>' +
      '<h3 class="wizard-step__subtitle">Kavurma Derecesi</h3>' +
      '<div class="choice-cards choice-cards--2col">' + roastOpts.map(function (r) { return btn(r, 'roast', state.roast, 'choice-card--roast'); }).join('') + '</div>' +
      '<h3 class="wizard-step__subtitle">\u00d6\u011f\u00fctme Tercihi</h3>' +
      '<div class="choice-cards choice-cards--2col">' + grindOpts.map(function (g) { return btn(g, 'grind', state.grind, 'choice-card--grind'); }).join('') + '</div>' +
    '</div>';
  }

  /* Step 5 */
  var KG_PRESETS = [5, 10, 20, 25, 30, 50, 60, 75, 100, 200];

  function step5() {
    var presetButtons = KG_PRESETS.map(function (v) {
      return '<button type="button" class="qty-preset-btn' + (state.kg === v ? ' is-active' : '') +
        '" data-action="qty-preset" data-value="' + v + '">' + v + ' kg</button>';
    }).join('');

    return '<div class="wizard-step">' +
      '<h2 class="wizard-step__title">Ka\u00e7 Kilogram?</h2>' +
      '<p class="wizard-step__desc">Minimum sipari\u015f 5 kg\u2019d\u0131r. Miktar artt\u0131k\u00e7a kg fiyat\u0131 d\u00fc\u015fer; 200 kg \u00fczeri sipari\u015fler i\u00e7in bizimle ileti\u015fime ge\u00e7in.</p>' +
      '<div class="qty-control">' +
        '<button type="button" class="qty-btn" data-action="qty-minus" aria-label="Azalt">-</button>' +
        '<div class="qty-display"><span class="qty-value">' + state.kg + '</span><span class="qty-unit">kg</span></div>' +
        '<button type="button" class="qty-btn" data-action="qty-plus" aria-label="Art\u0131r">+</button>' +
      '</div>' +
      '<div class="qty-presets">' + presetButtons + '</div>' +
    '</div>';
  }

  /* Step 6 */
  function step6() {
    var totalKg   = packagingKg();
    var remaining = +(state.kg - totalKg).toFixed(3);
    var ok        = Math.abs(remaining) < 0.001;
    var rows = [
      { key: 'p250',  label: '250 g paket', unit: '0.25 kg/adet', qty: state.packaging.p250  },
      { key: 'p1000', label: '1 kg paket',  unit: '1 kg/adet',    qty: state.packaging.p1000 },
      { key: 'p5000', label: '5 kg paket <span class="pkg-badge">%2 indirim</span>', unit: '5 kg/adet', qty: state.packaging.p5000 },
    ];
    var tableRows = rows.map(function (r) {
      var sub = r.key === 'p250' ? +(r.qty * 0.25).toFixed(2) : r.key === 'p1000' ? r.qty : r.qty * 5;
      return '<tr class="pkg-row">' +
        '<td class="pkg-row__label">' + r.label + '<br><small>' + r.unit + '</small></td>' +
        '<td class="pkg-row__qty"><div class="qty-control qty-control--sm">' +
          '<button type="button" class="qty-btn" data-action="pkg-minus" data-key="' + r.key + '">-</button>' +
          '<input type="number" class="qty-input qty-input--sm" data-action="pkg-input" data-key="' + r.key + '" min="0" value="' + r.qty + '">' +
          '<button type="button" class="qty-btn" data-action="pkg-plus" data-key="' + r.key + '">+</button>' +
        '</div></td>' +
        '<td class="pkg-row__sub">' + sub + ' kg</td>' +
      '</tr>';
    }).join('');
    return '<div class="wizard-step">' +
      '<h2 class="wizard-step__title">Ambalaj Da\u011f\u0131l\u0131m\u0131</h2>' +
      '<p class="wizard-step__desc">Toplam <strong>' + state.kg + ' kg</strong> sipari\u015finizi paket boyutlar\u0131na b\u00f6l\u00fc\u015ft\u00fcr\u00fcn.</p>' +
      '<table class="pkg-table"><thead><tr><th>Paket Boyutu</th><th>Adet</th><th>Toplam</th></tr></thead>' +
      '<tbody>' + tableRows + '</tbody>' +
      '<tfoot><tr class="pkg-total-row' + (ok ? ' pkg-total-row--ok' : '') + '">' +
        '<td colspan="2"><strong>Da\u011f\u0131t\u0131lan Toplam</strong></td>' +
        '<td><strong>' + totalKg.toFixed(2) + ' / ' + state.kg + ' kg</strong></td>' +
      '</tr></tfoot></table>' +
      '<div class="pkg-remaining' + (ok ? ' pkg-remaining--ok' : '') + '">' +
        (ok ? '\u2713 Da\u011f\u0131l\u0131m tamamland\u0131' : 'Kalan: ' + (remaining > 0 ? remaining.toFixed(2) + ' kg atanmam\u0131\u015f' : Math.abs(remaining).toFixed(2) + ' kg fazla')) +
      '</div>' +
      '<div class="pkg-custom-note"><p>\u00d6zelle\u015ftirilmi\u015f (logolu veya etiketli) ambalaj m\u0131 istiyorsunuz? <a href="' + (config.contactUrl || '/pages/iletisim') + '">Bize ula\u015f\u0131n</a>' +
        (config.whatsappNumber ? ' veya <a href="https://wa.me/' + config.whatsappNumber + '" target="_blank" rel="noopener">WhatsApp ile yaz\u0131n</a>.' : '.') +
      '</p></div>' +
    '</div>';
  }

  /* Step 7 */
  function step7() {
    var price = calculatePrice();
    var sel   = selectedBeans();
    var beanRows = sel.map(function (b, i) {
      var bean  = findBean(b.beanId);
      var label = sel.length > 1 ? (i + 1) + '. \u00c7ekirdek' : '\u00c7ekirdek';
      var val   = bean ? bean.name : b.beanId;
      if (state.beanStructure === 'blend') val += ' (%' + b.ratio + ')';
      return [label, val];
    });
    var rows = [
      ['Kullan\u0131m Alan\u0131',  usageLabel()],
      ['\u00c7ekirdek Yap\u0131s\u0131', structureLabel()],
    ].concat(beanRows).concat([
      ['Kavurma',           roastLabel()],
      ['\u00d6\u011f\u00fctme',            grindLabel()],
      ['Miktar',            state.kg + ' kg'],
      ['Ambalaj',           packagingSummaryText()],
    ]).filter(function (r) { return r && r[1]; });

    var summaryHtml = '<div class="wizard-step">' +
      '<h2 class="wizard-step__title">Sipari\u015finizi \u0130ncele</h2>' +
      '<p class="wizard-step__desc">Her se\u00e7imi kontrol edin. D\u00fczenlemek istedi\u011finiz ad\u0131ma d\u00f6nebilirsiniz.</p>' +
      '<table class="summary-table">' + rows.map(function (r) { return '<tr><th>' + r[0] + '</th><td>' + r[1] + '</td></tr>'; }).join('') + '</table>' +
      (price ? '<div class="summary-price">' +
        '<div class="summary-price__info"><span>' + formatMoney(price.perKg) + ' / kg &times; ' + state.kg + ' kg</span>' +
        (price.tierPct > 0 ? '<span class="summary-price__discount">Miktar indirimi (%' + price.tierPct + ') uygulandı</span>' : '') +
        (price.discount > 0 ? '<span class="summary-price__discount">5 kg ambalaj indirimi (%2): −' + formatMoney(price.discount) + '</span>' : '') +
        '<strong>' + formatMoney(price.total) + '</strong>' +
        '<p class="summary-price__note">Tahmini fiyatt\u0131r, sipari\u015f onay\u0131ndan sonra kesinle\u015fir.</p></div>' +
        '<div class="summary-price__actions">' +
        '<button type="button" class="summary-price__btn summary-price__btn--secondary" data-action="summary-add-cart">Sepete Ekle</button>' +
        '<button type="button" class="summary-price__btn summary-price__btn--primary" data-action="summary-checkout">\u00d6demeye Ge\u00e7 \u2192</button>' +
        '</div></div>' : '');

    summaryHtml += buildSubscriptionBox();

    summaryHtml += '</div>';
    return summaryHtml;
  }

  function buildSubscriptionBox() {
    if (!state.subscriptionMode) {
      return '<div class="sub-invite">' +
        '<div class="sub-invite__content">' +
          '<div class="sub-invite__icon-spacer"></div>' +
          '<div>' +
            '<strong>Bu Blend\'i D\u00fczenli Al\u0131n</strong>' +
            '<p>Ayn\u0131 blend\u0131 periyodik olarak kap\u0131n\u0131za getirin. Fiyat kilitlenir, her seferinde se\u00e7im yapman\u0131za gerek kalmaz.</p>' +
          '</div>' +
        '</div>' +
        '<button class="sub-invite__btn" data-action="sub-toggle">Abonelik Olarak Devam Et \u2192</button>' +
      '</div>';
    }

    // Subscription sub-panel
    var freqOptions = [
      { value: 'weekly',   label: 'Haftada 1',   deliveriesPerMonth: 4 },
      { value: 'biweekly', label: '2 Haftada 1', deliveriesPerMonth: 2 },
      { value: 'monthly',  label: 'Ayda 1',       deliveriesPerMonth: 1 },
    ];
    var durOptions = [
      { months: 3, label: '3 Ay' },
      { months: 6, label: '6 Ay' },
    ];
    var days = [
      { value: 'monday',    label: 'Pazartesi' },
      { value: 'tuesday',   label: 'Sal\u0131' },
      { value: 'wednesday', label: '\u00c7ar\u015famba' },
      { value: 'thursday',  label: 'Per\u015fembe' },
      { value: 'friday',    label: 'Cuma' },
    ];

    var freqHtml = '<div class="sub-option-group">' +
      '<label class="sub-option-label">Teslimat S\u0131kl\u0131\u011f\u0131</label>' +
      '<div class="sub-chips">' +
      freqOptions.map(function (f) {
        var active = state.subFrequency === f.value ? ' sub-chip--active' : '';
        return '<button class="sub-chip' + active + '" data-action="sub-freq" data-value="' + f.value + '">' + f.label + '</button>';
      }).join('') +
      '</div></div>';

    var durHtml = '<div class="sub-option-group">' +
      '<label class="sub-option-label">S\u00fcre</label>' +
      '<div class="sub-chips">' +
      durOptions.map(function (d) {
        var active = state.subDuration === d.months ? ' sub-chip--active' : '';
        return '<button class="sub-chip' + active + '" data-action="sub-dur" data-value="' + d.months + '">' + d.label + '</button>';
      }).join('') +
      '</div></div>';

    var dayHtml = '<div class="sub-option-group">' +
      '<label class="sub-option-label">Tercih Edilen Teslimat G\u00fcn\u00fc</label>' +
      '<div class="sub-chips">' +
      days.map(function (d) {
        var active = state.subDay === d.value ? ' sub-chip--active' : '';
        return '<button class="sub-chip' + active + '" data-action="sub-day" data-value="' + d.value + '">' + d.label + '</button>';
      }).join('') +
      '</div></div>';

    var subTotalHtml = '';
    if (state.subFrequency && state.subDuration) {
      var freqMap = { weekly: 4, biweekly: 2, monthly: 1 };
      var deliveriesPerMonth = freqMap[state.subFrequency] || 1;
      var totalDeliveries = deliveriesPerMonth * state.subDuration;
      var subPrice = calcSubPerKg(state.subDuration);
      if (subPrice) {
        var perDelivery = Math.round(subPrice * state.kg * 100) / 100;
        var grandTotal  = Math.round(perDelivery * totalDeliveries * 100) / 100;

        // Normal (tek seferlik) fiyatla kar\u015f\u0131la\u015ft\u0131rma: her iki fiyat da
        // sunucudan (Supabase k\u00e2r \u00e7arpanlar\u0131) geldi\u011fi i\u00e7in admin panelinden
        // oranlar de\u011fi\u015fti\u011finde indirim g\u00f6sterimi kendili\u011finden g\u00fcncellenir.
        var oneTime = calculatePrice();
        var oneTimePerKg = oneTime ? oneTime.perKg : 0;
        var kgRowVal, saveRow = '';
        if (oneTimePerKg > subPrice + 0.005) {
          var discountPct = Math.round((1 - subPrice / oneTimePerKg) * 100);
          var totalSave   = Math.round((oneTimePerKg - subPrice) * state.kg * totalDeliveries * 100) / 100;
          kgRowVal = '<span class="sub-price-old">' + formatMoney(oneTimePerKg) + '/kg</span>' +
            '<strong>' + formatMoney(subPrice) + '/kg</strong>' +
            (discountPct > 0 ? '<span class="sub-discount-badge">%' + discountPct + ' indirim</span>' : '');
          if (totalSave > 0) {
            saveRow = '<div class="sub-total-row sub-total-row--save"><span>Normal al\u0131ma g\u00f6re kazanc\u0131n\u0131z</span><strong>' + formatMoney(totalSave) + '</strong></div>';
          }
        } else {
          kgRowVal = '<strong>' + formatMoney(subPrice) + '/kg</strong>';
        }

        subTotalHtml = '<div class="sub-total-preview">' +
          '<div class="sub-total-row"><span>Kg fiyat\u0131 (abonelik, sabit)</span><span class="sub-price-cell">' + kgRowVal + '</span></div>' +
          '<div class="sub-total-row"><span>Teslimat ba\u015f\u0131na (' + state.kg + ' kg)</span><strong>' + formatMoney(perDelivery) + '</strong></div>' +
          '<div class="sub-total-row sub-total-row--grand"><span>Toplam (' + totalDeliveries + ' teslimat)</span><strong>' + formatMoney(grandTotal) + '</strong></div>' +
          saveRow +
          '<p class="sub-total-note">Tek \u00f6deme al\u0131n\u0131r; kg fiyat\u0131 abonelik boyunca sabit kal\u0131r. Tahmini fiyatt\u0131r, sipari\u015f onay\u0131ndan sonra kesinle\u015fir.</p>' +
        '</div>';
      }
    }

    return '<div class="sub-panel">' +
      '<div class="sub-panel__header">' +
        '<strong>Abonelik Detaylar\u0131</strong>' +
        '<button class="sub-panel__cancel" data-action="sub-toggle">Vazge\u00e7</button>' +
      '</div>' +
      freqHtml + durHtml + dayHtml + subTotalHtml +
    '</div>';
  }

  /* ── Event handlers (bound ONCE in init) ───────────────────── */
  function onContentClick(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.dataset.action;
    var value  = btn.dataset.value;
    var beanId = btn.dataset.beanId;

    if (action === 'usage') {
      state.usageType = value;
      state.grind = value === 'espresso' ? 'whole' : null;
      rerenderAndAside();
      setTimeout(function() { nextStep(); }, 200);
    }
    if (action === 'structure') {
      state.beanStructure = value;
      state.beans = [{beanId:null,ratio:0},{beanId:null,ratio:0},{beanId:null,ratio:0}];
      rerenderAndAside();
      setTimeout(function() { nextStep(); }, 200);
    }
    if (action === 'bean-detail') {
      var card = btn.closest('.bcf');
      if (card) card.classList.toggle('is-flipped');
      return;
    }
    if (action === 'bean-select-single') {
      if (isBeanOOS(beanId)) { showError('Bu çekirdek şu anda stokta yok.'); return; }
      state.beans[0].beanId = beanId;
      rerenderAndAside();
      setTimeout(function() { nextStep(); }, 200);
    }
    if (action === 'bean-toggle-blend') {
      if (isBeanOOS(beanId)) { showError('Bu çekirdek şu anda stokta yok.'); return; }
      toggleBlendBean(beanId); rerenderAndAside();
    }
    if (action === 'ratio-minus' || action === 'ratio-plus') {
      // Elle rakam girilemez: oran yalnızca 10'luk adımlarla 10-90 arasında
      // değişir (küsuratlı/serbest girişle oynanmasın diye).
      var ri  = parseInt(btn.dataset.index);
      if (state.beans[ri]) {
        var cur  = parseInt(state.beans[ri].ratio) || 0;
        var next = action === 'ratio-plus' ? cur + 10 : cur - 10;
        state.beans[ri].ratio = Math.max(10, Math.min(90, next));
        rerenderAndAside();
      }
    }
    if (action === 'roast') {
      state.roast = value;
      rerenderAndAside();
      if (state.usageType === 'espresso') {
        setTimeout(function() { nextStep(); }, 200);
      } else {
        setTimeout(function() {
          var grindEl = document.querySelector('.choice-card--grind');
          if (grindEl) grindEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }
    if (action === 'grind') {
      state.grind = value;
      rerenderAndAside();
      setTimeout(function() { nextStep(); }, 200);
    }
    if (action === 'recipe-select') {
      var recipe = (config.recipes || []).find(function (r) { return r.id === btn.dataset.recipeId; });
      if (!recipe) return;
      state.beanStructure = recipe.beans.length === 1 ? 'single' : 'blend';
      state.beans = [
        recipe.beans[0] ? { beanId: recipe.beans[0].beanId, ratio: recipe.beans[0].ratio } : { beanId: null, ratio: 0 },
        recipe.beans[1] ? { beanId: recipe.beans[1].beanId, ratio: recipe.beans[1].ratio } : { beanId: null, ratio: 0 },
        recipe.beans[2] ? { beanId: recipe.beans[2].beanId, ratio: recipe.beans[2].ratio } : { beanId: null, ratio: 0 },
      ];
      state.roast = recipe.roast;
      state.grind = recipe.grind;
      state.step  = 4;
      go();
    }
    if (action === 'qty-minus') {
      var kgIdxM = KG_PRESETS.indexOf(state.kg);
      if (kgIdxM > 0) { state.kg = KG_PRESETS[kgIdxM - 1]; rerenderAndAside(); }
    }
    if (action === 'qty-plus') {
      var kgIdxP = KG_PRESETS.indexOf(state.kg);
      if (kgIdxP === -1 || kgIdxP === KG_PRESETS.length - 1) { showBulkModal(); }
      else { state.kg = KG_PRESETS[kgIdxP + 1]; rerenderAndAside(); }
    }
    if (action === 'qty-preset') {
      var kgVal = parseInt(btn.dataset.value, 10);
      if (KG_PRESETS.indexOf(kgVal) >= 0) { state.kg = kgVal; rerenderAndAside(); }
    }
    if (action === 'pkg-minus')         { var k  = btn.dataset.key; state.packaging[k]  = Math.max(0, state.packaging[k]  - 1); rerenderAndAside(); }
    if (action === 'pkg-plus')          { var k2 = btn.dataset.key; state.packaging[k2] = Math.max(0, state.packaging[k2] + 1); rerenderAndAside(); }
    if (action === 'sub-toggle')        { state.subscriptionMode = !state.subscriptionMode; rerenderAndAside(); updateProgress(); }
    if (action === 'sub-freq')          { state.subFrequency = value; rerenderAndAside(); }
    if (action === 'sub-dur')           { state.subDuration = parseInt(value); rerenderAndAside(); }
    if (action === 'sub-day')           { state.subDay = value; rerenderAndAside(); }
    if (action === 'summary-add-cart')  { addToLocalCart(); }
    if (action === 'summary-checkout')  { addToLocalCart(); checkoutCart(); }
  }

  function onContentChange(e) {
    var el     = e.target;
    var action = el.dataset.action;
    if (action === 'pkg-input')  { var k3 = el.dataset.key; state.packaging[k3] = Math.max(0, parseInt(el.value) || 0); rerenderAndAside(); }
  }

  function rerenderAndAside() { renderStep(state.step); updateAside(); saveState(); }

  /* ── Local cart helpers ────────────────────────────────────── */
  function onAsideClick(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    if (btn.dataset.action === 'wizard-reset') {
      resetState();
      go();
      updateProgress();
      return;
    }
    if (btn.dataset.action === 'cart-remove') {
      var id = parseInt(btn.dataset.id);
      saveCart(getCart().filter(function (item) { return item.id !== id; }));
      delete cartSub.items[id];
      updateCartSection();
    }
    if (btn.dataset.action === 'cart-checkout')    { checkoutCart(); }
    if (btn.dataset.action === 'cart-sub-toggle')  { cartSub.mode = !cartSub.mode; updateCartSection(); }
    if (btn.dataset.action === 'cart-sub-freq')  {
      var idf = btn.dataset.itemId;
      if (!cartSub.items[idf]) cartSub.items[idf] = {};
      cartSub.items[idf].frequency = btn.dataset.value;
      updateCartSection();
    }
    if (btn.dataset.action === 'cart-sub-dur') {
      var idd = btn.dataset.itemId;
      if (!cartSub.items[idd]) cartSub.items[idd] = {};
      cartSub.items[idd].duration = parseInt(btn.dataset.value);
      updateCartSection();
    }
    if (btn.dataset.action === 'cart-sub-day')     { cartSub.day = btn.dataset.value; updateCartSection(); }
    if (btn.dataset.action === 'cart-sub-confirm') { createCartSubscriptions(); }
  }

  function updateCartSection() {
    var el = document.getElementById('wizard-cart-section');
    if (!el) return;
    var cart = getCart();
    if (!cart.length) { el.style.display = 'none'; el.innerHTML = ''; return; }
    el.style.display = 'block';
    var total = cart.reduce(function (s, item) { return s + item.total; }, 0);
    el.innerHTML =
      '<div class="cart-divider"></div>' +
      '<span class="cart-header__title">Sepetim (' + cart.length + ' \u00fcr\u00fcn)</span>' +
      cart.map(function (item) {
        return '<div class="cart-item">' +
          '<div class="cart-item__info">' +
            '<strong>' + item.label + '</strong>' +
            '<span>' + item.kg + ' kg &nbsp;&middot;&nbsp; ' + formatMoney(item.total) + '</span>' +
          '</div>' +
          (cartSub.mode ? '' : '<button class="cart-item__remove" type="button" data-action="cart-remove" data-id="' + item.id + '" title="Kald\u0131r">&times;</button>') +
        '</div>';
      }).join('') +
      (!cartSub.mode
        ? '<div class="cart-total"><span>Toplam</span><strong>' + formatMoney(total) + '</strong></div>' +
          '<button type="button" class="btn btn--primary cart-checkout-btn" data-action="cart-checkout">\u00d6demeye Ge\u00e7 \u2192</button>' +
          '<button type="button" class="cart-sub-toggle-btn" data-action="cart-sub-toggle">Abonelik Olarak Sipari\u015f Ver</button>'
        : buildCartSubForm(cart)
      );
  }

  function buildItemProperties(sel) {
    var props = [
      { name: 'Kullan\u0131m Alan\u0131',   value: usageLabel()     },
      { name: '\u00c7ekirdek Yap\u0131s\u0131', value: structureLabel() },
    ];
    sel.forEach(function (b, i) {
      var bean = findBean(b.beanId);
      var key  = sel.length > 1 ? (i + 1) + '. \u00c7ekirdek' : '\u00c7ekirdek';
      var val  = bean ? bean.name : b.beanId;
      if (state.beanStructure === 'blend') val += ' %' + b.ratio;
      props.push({ name: key, value: val });
      props.push({ name: '_bean_' + (i + 1) + '_id',    value: String(b.beanId) });
      props.push({ name: '_bean_' + (i + 1) + '_ratio', value: String(b.ratio || 100) });
    });
    props.push({ name: 'Kavurma',      value: roastLabel()          });
    props.push({ name: '\u00d6\u011f\u00fctme',       value: grindLabel()          });
    props.push({ name: 'Miktar (kg)',  value: String(state.kg)      });
    props.push({ name: 'Ambalaj',      value: packagingSummaryText() });
    return props;
  }

  function addToLocalCart() {
    var variantId = (config.variants || {})[state.usageType] || null;
    if (!variantId || variantId === 'PLACEHOLDER') {
      showError('Sepet yap\u0131land\u0131rmas\u0131 eksik. L\u00fctfen ma\u011faza sahibiyle ileti\u015fime ge\u00e7in.');
      return;
    }
    if (!canAddToCart()) return;
    var price = calculatePrice();
    if (!price) { showError('Fiyat hesaplanam\u0131yor.'); return; }

    var sel = selectedBeans();

    var beanLabel = sel.map(function (b) {
      var bean = findBean(b.beanId);
      var name = bean ? bean.name : b.beanId;
      return state.beanStructure === 'blend' ? name + ' %' + b.ratio : name;
    }).join(', ');

    var item = {
      id:         Date.now(),
      label:      usageLabel() + ', ' + (state.beanStructure === 'single' ? beanLabel : '\u00d6zel Blend'),
      beanLabel:  beanLabel,
      kg:         state.kg,
      pricePerKg: Math.round(price.perKg  * 100) / 100,
      total:      Math.round(price.total  * 100) / 100,
      variantId:  variantId,
      /* Sunucu indirimi bu adetlerden kendisi doğrulayıp hesaplar */
      packaging:  { p250: state.packaging.p250, p1000: state.packaging.p1000, p5000: state.packaging.p5000 },
      /* Abonelik önizlemesi için süre bazlı SATIŞ fiyatı (TL/kg) — maliyet verisi saklanmaz */
      subPerKg: { '3': calcSubPerKg(3), '6': calcSubPerKg(6) },
      beans:      sel.map(function (b) {
        var bean = findBean(b.beanId);
        return { id: b.beanId, ratio: b.ratio || 100, name: bean ? bean.name : b.beanId, countryCode: bean ? bean.countryCode : '' };
      }),
      properties: buildItemProperties(sel),
    };

    var cart = getCart();
    cart.push(item);
    saveCart(cart);
    window.dispatchEvent(new CustomEvent('tkahve:cart-updated'));

    trackEvent('add_to_cart', {
      currency: 'TRY',
      value: item.total,
      items: [{ item_name: item.label, quantity: item.kg }],
    });

    resetWizard();
  }

  function resetWizard() {
    state.step            = 1;
    state.usageType       = null;
    state.beanStructure   = null;
    state.beans           = [{ beanId: null, ratio: 0 }, { beanId: null, ratio: 0 }, { beanId: null, ratio: 0 }];
    state.roast           = null;
    state.grind           = null;
    state.kg              = 5;
    state.packaging       = { p250: 0, p1000: 0, p5000: 0 };
    state.subscriptionMode = false;
    state.subFrequency    = null;
    state.subDuration     = null;
    state.subDay          = null;
    go();
  }

  /* ── Cart subscription form (per-item settings) ─────────────── */
  function buildCartSubForm(cart) {
    var freqOptions = [
      { value: 'weekly',   label: 'Haftada 1' },
      { value: 'biweekly', label: '2 Haftada 1' },
      { value: 'monthly',  label: 'Ayda 1' },
    ];
    var durOptions = [
      { months: 3, label: '3 Ay' },
      { months: 6, label: '6 Ay' },
    ];
    var days = [
      { value: 'monday',    label: 'Pzt' },
      { value: 'tuesday',   label: 'Sal\u0131' },
      { value: 'wednesday', label: '\u00c7ar' },
      { value: 'thursday',  label: 'Per' },
      { value: 'friday',    label: 'Cum' },
    ];
    var freqMap = { weekly: 4, biweekly: 2, monthly: 1 };

    var allReady = cart.every(function (item) {
      var s = cartSub.items[item.id] || {};
      return s.frequency && s.duration;
    });

    // Per-item rows
    var itemsHtml = cart.map(function (item) {
      var s    = cartSub.items[item.id] || {};
      var iid  = String(item.id);
      var itemTotal = '';
      if (s.frequency && s.duration) {
        var del = (freqMap[s.frequency] || 1) * s.duration;
        var subPpkg = calcSubPriceForItem(item, s.duration);
        // Normal fiyatla karşılaştırma: iki fiyat da sunucu kâr çarpanlarından
        // gelir, oranlar admin panelinden değişince gösterim kendini günceller.
        var oneKg = parseFloat(item.pricePerKg) || 0;
        var kgLine = '';
        if (subPpkg > 0 && oneKg > subPpkg + 0.005) {
          var pct = Math.round((1 - subPpkg / oneKg) * 100);
          kgLine = '<div class="cart-sub-item-price">' +
            '<span class="sub-price-old">' + formatMoney(oneKg) + '/kg</span>' +
            '<strong>' + formatMoney(subPpkg) + '/kg</strong>' +
            (pct > 0 ? '<span class="sub-discount-badge">%' + pct + ' indirim</span>' : '') +
          '</div>';
        }
        itemTotal = kgLine + '<div class="cart-sub-item-total">' + del + ' teslimat &middot; ' + formatMoney(Math.round(subPpkg * item.kg * del * 100) / 100) + '</div>';
      }
      return '<div class="cart-sub-item">' +
        '<div class="cart-sub-item__name">' + item.label + ' · ' + item.kg + ' kg</div>' +
        '<div class="sub-option-group" style="margin-bottom:0.5rem">' +
          '<label class="sub-option-label">S\u0131kl\u0131k</label>' +
          '<div class="sub-chips">' +
          freqOptions.map(function (f) {
            return '<button class="sub-chip' + (s.frequency === f.value ? ' sub-chip--active' : '') + '" data-action="cart-sub-freq" data-value="' + f.value + '" data-item-id="' + iid + '" type="button">' + f.label + '</button>';
          }).join('') + '</div></div>' +
        '<div class="sub-option-group" style="margin-bottom:0.25rem">' +
          '<label class="sub-option-label">S\u00fcre</label>' +
          '<div class="sub-chips">' +
          durOptions.map(function (d) {
            return '<button class="sub-chip' + (s.duration === d.months ? ' sub-chip--active' : '') + '" data-action="cart-sub-dur" data-value="' + d.months + '" data-item-id="' + iid + '" type="button">' + d.label + '</button>';
          }).join('') + '</div></div>' +
        itemTotal +
      '</div>';
    }).join('');

    var dayHtml = '<div class="sub-option-group">' +
      '<label class="sub-option-label">Tercih Edilen Teslimat G\u00fcn\u00fc</label>' +
      '<div class="sub-chips">' +
      days.map(function (d) {
        return '<button class="sub-chip' + (cartSub.day === d.value ? ' sub-chip--active' : '') + '" data-action="cart-sub-day" data-value="' + d.value + '" type="button">' + d.label + '</button>';
      }).join('') + '</div></div>';

    var grandTotal = 0, normalTotal = 0;
    if (allReady) {
      cart.forEach(function (item) {
        var s   = cartSub.items[item.id] || {};
        var del = (freqMap[s.frequency] || 1) * s.duration;
        grandTotal  += Math.round(calcSubPriceForItem(item, s.duration) * item.kg * del * 100) / 100;
        normalTotal += Math.round((parseFloat(item.pricePerKg) || 0) * item.kg * del * 100) / 100;
      });
    }
    var totalsHtml = '';
    if (allReady) {
      var saveTotal = Math.round((normalTotal - grandTotal) * 100) / 100;
      totalsHtml = '<div class="sub-total-preview">' +
        '<div class="sub-total-row sub-total-row--grand"><span>Toplam (t\u00fcm abonelikler)</span><strong>' + formatMoney(grandTotal) + '</strong></div>' +
        (saveTotal > 0.5 ? '<div class="sub-total-row sub-total-row--save"><span>Normal al\u0131ma g\u00f6re kazanc\u0131n\u0131z</span><strong>' + formatMoney(saveTotal) + '</strong></div>' : '') +
        '<p class="sub-total-note">Tek \u00f6deme al\u0131n\u0131r, her \u00fcr\u00fcn i\u00e7in ayr\u0131 abonelik olu\u015fturulur. Kg fiyatlar\u0131 abonelik boyunca sabit kal\u0131r.</p></div>';
    }

    return '<div class="cart-sub-form">' +
      '<div class="cart-sub-form__header">' +
        '<strong>Abonelik Detaylar\u0131</strong>' +
        '<button type="button" class="sub-panel__cancel" data-action="cart-sub-toggle">Vazge\u00e7</button>' +
      '</div>' +
      itemsHtml + dayHtml + totalsHtml +
      '<button type="button" class="btn btn--primary cart-checkout-btn" data-action="cart-sub-confirm"' + (allReady ? '' : ' disabled') + '>Abonelik \u00d6demesine Ge\u00e7 \u2192</button>' +
    '</div>';
  }

  function calcSubPriceForItem(item, months) {
    // Sepete eklenirken kaydedilen süre bazlı SATIŞ fiyatı (TL/kg).
    // Eski sepet kayıtlarında yoksa tek-seferlik fiyata düşer; kesin fiyat
    // her durumda sunucuda hesaplanır.
    var perKg = parseFloat((item.subPerKg || {})[String(months)]) || 0;
    return perKg > 0 ? perKg : (parseFloat(item.pricePerKg) || 0);
  }

  function createCartSubscriptions(agreementAcceptedAt) {
    var cart = getCart();
    var allReady = cart.length && cart.every(function (item) {
      var s = cartSub.items[item.id] || {};
      return s.frequency && s.duration;
    });
    if (!allReady) return;
    if (typeof agreementAcceptedAt !== 'string') {
      requireAgreement(createCartSubscriptions);
      return;
    }

    var confirmBtn = document.querySelector('[data-action="cart-sub-confirm"]');
    if (confirmBtn) { confirmBtn.disabled = true; confirmBtn.textContent = 'Y\u00fckleniyor...'; }

    fetch('https://toptankahve-checkout.vercel.app/api/create-cart-subscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: cart.map(function (item) {
          var s = cartSub.items[item.id] || {};
          return {
            kg:                item.kg,
            beans:             item.beans,
            label:             item.label,
            variantId:         item.variantId || null,
            deliveryFrequency: s.frequency,
            durationMonths:    s.duration,
            blendDetails:      { beans: item.beans, label: item.label, preferredDay: cartSub.day },
          };
        }),
        deliveryDay:       cartSub.day,
        customerId:    (window.tkahveCustomer || {}).id || null,
        customerEmail: (window.tkahveCustomer || {}).email || null,
        agreementAccepted: true,
      }),
    })
    .then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
        return data;
      });
    })
    .then(function (data) {
      // Sepeti ödeme tamamlanınca temizle; ödemeden dönülürse korunur.
      markPendingOrder(data.draftOrderId);
      window.location.href = data.checkoutUrl;
    })
    .catch(function (err) {
      if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'Abonelik \u00d6demesine Ge\u00e7 \u2192'; }
      showError('Abonelik olu\u015fturulurken hata: ' + (err.message || 'Bilinmeyen hata'));
    });
  }

  /* ── Checkout ──────────────────────────────────────────────── */
  function checkoutCart() {
    var cart = getCart();
    if (!cart.length) { showError('Sepetiniz bo\u015f.'); return; }

    trackEvent('begin_checkout', {
      currency: 'TRY',
      value: cart.reduce(function (s, item) { return s + (parseFloat(item.total) || 0); }, 0),
      items: cart.map(function (item) { return { item_name: item.label, quantity: item.kg }; }),
    });

    var checkoutBtn = document.querySelector('[data-action="cart-checkout"]');
    if (checkoutBtn) { checkoutBtn.disabled = true; checkoutBtn.textContent = 'Y\u00fckleniyor...'; }

    fetch('https://toptankahve-checkout.vercel.app/api/create-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId:    (window.tkahveCustomer || {}).id || null,
        customerEmail: (window.tkahveCustomer || {}).email || null,
        items: cart.map(function (item) {
          return {
            type:       item.type,
            variantId:  item.variantId,
            kg:         item.kg,
            beans:      item.beans,
            label:      item.label,
            properties: item.properties,
            packaging:  item.packaging || null,
          };
        }),
      }),
    })
    .then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
        return data;
      });
    })
    .then(function (data) {
      // Sepeti ödeme tamamlanınca temizle; ödemeden dönülürse korunur.
      markPendingOrder(data.draftOrderId);
      window.location.href = data.checkoutUrl;
    })
    .catch(function (err) {
      if (checkoutBtn) { checkoutBtn.disabled = false; checkoutBtn.textContent = '\u00d6demeye Ge\u00e7 \u2192'; }
      showError('Sipari\u015f olu\u015fturulurken hata: ' + (err.message || 'Bilinmeyen hata'));
    });
  }

  /* ── Subscription ─────────────────────────────────────────── */
  /* \u00d6demeye ge\u00e7meden \u00f6nce Abonelik S\u00f6zle\u015fmesi onay\u0131 zorunlu (modal).
     Sunucu da agreementAccepted olmadan reddeder \u2014 buras\u0131 sadece UX. */
  function requireAgreement(cb) {
    if (typeof window.tkahveAgreementConfirm !== 'function') {
      showError('S\u00f6zle\u015fme onay penceresi y\u00fcklenemedi. L\u00fctfen sayfay\u0131 yenileyip tekrar deneyin.');
      return;
    }
    window.tkahveAgreementConfirm(cb);
  }

  function createSubscriptionFromWizard(agreementAcceptedAt) {
    if (!state.subFrequency || !state.subDuration) {
      showError('L\u00fctfen teslimat s\u0131kl\u0131\u011f\u0131n\u0131 ve s\u00fcreyi se\u00e7in.');
      return;
    }
    // Event objesi vb. gelirse onay say\u0131lmaz \u2014 yaln\u0131zca modaldan gelen ISO string ge\u00e7erli.
    if (typeof agreementAcceptedAt !== 'string') {
      requireAgreement(createSubscriptionFromWizard);
      return;
    }

    var btn      = document.getElementById('wizard-next');
    var asideBtn = document.getElementById('wizard-aside-add');
    if (btn)      { btn.disabled = true;      btn.textContent      = 'Y\u00fckleniyor...'; }
    if (asideBtn) { asideBtn.disabled = true; asideBtn.textContent = 'Y\u00fckleniyor...'; }

    var sel = selectedBeans();

    var blendDetails = {
      beans: sel.map(function (b) {
        var bean = findBean(b.beanId);
        return { id: b.beanId, name: bean ? bean.name : b.beanId, ratio: b.ratio || 100 };
      }),
      usageType:     state.usageType,
      beanStructure: state.beanStructure,
      roast:         state.roast,
      grind:         state.grind,
      preferredDay:  state.subDay,
    };

    fetch('https://toptankahve-checkout.vercel.app/api/create-subscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId:    (window.tkahveCustomer || {}).id || null,
        customerEmail: (window.tkahveCustomer || {}).email || null,
        beans:             sel.map(function (b) { return { id: b.beanId, ratio: b.ratio || 100 }; }),
        quantityPerKg:    state.kg,
        deliveryFrequency: state.subFrequency,
        durationMonths:   state.subDuration,
        blendDetails:     blendDetails,
        agreementAccepted: true,
        // Checkout'ta ürün görseli çıksın diye kullanım tipine karşılık gelen varyant
        variantId:         (config.variants || {})[state.usageType] || null,
      }),
    })
    .then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
        return data;
      });
    })
    .then(function (data) { window.location.href = data.checkoutUrl; })
    .catch(function (err) {
      if (btn)      { btn.disabled = false;      btn.textContent      = 'Abonelik \u00d6demesine Ge\u00e7'; }
      if (asideBtn) { asideBtn.disabled = false; asideBtn.textContent = 'Abonelik \u00d6demesine Ge\u00e7'; }
      showError('Abonelik olu\u015fturulurken hata: ' + (err.message || 'Bilinmeyen hata'));
    });
  }

  /* ── Bulk contact modal ────────────────────────────────────── */
  function injectBulkModalStyles() {
    if (document.getElementById('bulk-modal-styles')) return;
    var style = document.createElement('style');
    style.id = 'bulk-modal-styles';
    style.textContent = [
      '.bulk-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9000;display:flex;align-items:center;justify-content:center;padding:1rem}',
      '.bulk-modal{background:#fff;border-radius:16px;padding:2rem 2rem 1.75rem;width:100%;max-width:480px;max-height:90vh;overflow-y:auto;position:relative;box-shadow:0 20px 60px rgba(0,0,0,.25)}',
      '.bulk-modal__close{position:absolute;top:1rem;right:1rem;background:none;border:none;cursor:pointer;font-size:1.5rem;line-height:1;opacity:.45;padding:.25rem .5rem}',
      '.bulk-modal__close:hover{opacity:.9}',
      '.bulk-modal__title{font-size:1.25rem;font-weight:700;margin:0 0 .375rem}',
      '.bulk-modal__desc{font-size:.9rem;opacity:.65;margin:0 0 1.5rem;line-height:1.5}',
      '.bulk-modal__field{margin-bottom:1rem}',
      '.bulk-modal__label{display:block;font-size:.8125rem;font-weight:600;margin-bottom:.3rem}',
      '.bulk-modal__input{width:100%;border:1.5px solid #ddd;border-radius:8px;padding:.625rem .875rem;font-size:.9375rem;font-family:inherit;box-sizing:border-box;transition:border-color .15s}',
      '.bulk-modal__input:focus{outline:none;border-color:#6b3a2a}',
      'textarea.bulk-modal__input{resize:vertical;min-height:80px}',
      '.bulk-modal__actions{display:flex;gap:.75rem;margin-top:1.5rem}',
      '.bulk-modal__submit{flex:1;padding:.75rem 1.25rem;background:#6b3a2a;color:#fff;border:none;border-radius:8px;font-size:.9375rem;font-weight:600;cursor:pointer;transition:opacity .15s}',
      '.bulk-modal__submit:hover:not(:disabled){opacity:.85}',
      '.bulk-modal__submit:disabled{opacity:.5;cursor:not-allowed}',
      '.bulk-modal__cancel{padding:.75rem 1.25rem;background:transparent;border:1.5px solid #ddd;border-radius:8px;font-size:.9375rem;font-weight:600;cursor:pointer}',
      '.bulk-modal__success{text-align:center;padding:1.5rem 0 .5rem}',
      '.bulk-modal__success-icon{font-size:2.5rem;margin-bottom:.75rem}',
      '.bulk-modal__success h3{font-size:1.1rem;font-weight:700;margin:0 0 .5rem}',
      '.bulk-modal__success p{font-size:.9rem;opacity:.65;margin:0 0 1.5rem}'
    ].join('');
    document.head.appendChild(style);
  }

  function showBulkModal() {
    if (document.getElementById('bulk-modal-overlay')) return;
    injectBulkModalStyles();

    var overlay = document.createElement('div');
    overlay.id = 'bulk-modal-overlay';
    overlay.className = 'bulk-modal-overlay';
    overlay.innerHTML =
      '<div class="bulk-modal" role="dialog" aria-modal="true" aria-labelledby="bulk-modal-title">' +
        '<button type="button" class="bulk-modal__close" id="bulk-modal-close" aria-label="Kapat">&times;</button>' +
        '<h2 class="bulk-modal__title" id="bulk-modal-title">200 kg Üzeri Sipariş</h2>' +
        '<p class="bulk-modal__desc">200 kg üzeri siparişler için ekibimiz size özel fiyat ve lojistik düzenleme yapar. Bilgilerinizi bırakın, sizi arayalım.</p>' +
        '<form id="bulk-contact-form" novalidate>' +
          '<div class="bulk-modal__field">' +
            '<label class="bulk-modal__label" for="bulk-name">Ad Soyad <span aria-hidden="true">*</span></label>' +
            '<input type="text" id="bulk-name" name="contact[name]" class="bulk-modal__input" placeholder="Adınız Soyadınız" required>' +
          '</div>' +
          '<div class="bulk-modal__field">' +
            '<label class="bulk-modal__label" for="bulk-email">E-posta <span aria-hidden="true">*</span></label>' +
            '<input type="email" id="bulk-email" name="contact[email]" class="bulk-modal__input" placeholder="ornek@sirket.com" required>' +
          '</div>' +
          '<div class="bulk-modal__field">' +
            '<label class="bulk-modal__label" for="bulk-phone">Telefon</label>' +
            '<input type="tel" id="bulk-phone" name="contact[phone]" class="bulk-modal__input" placeholder="0532 000 00 00">' +
          '</div>' +
          '<div class="bulk-modal__field">' +
            '<label class="bulk-modal__label" for="bulk-qty">İhtiyaç Duyulan Miktar (kg)</label>' +
            '<input type="number" id="bulk-qty" name="contact[body_qty]" class="bulk-modal__input" placeholder="örn. 200" min="101" step="1">' +
          '</div>' +
          '<div class="bulk-modal__field">' +
            '<label class="bulk-modal__label" for="bulk-note">Not (opsiyonel)</label>' +
            '<textarea id="bulk-note" name="contact[body]" class="bulk-modal__input" placeholder="Blend tercihiniz, teslimat bölgesi vb."></textarea>' +
          '</div>' +
          '<div class="bulk-modal__actions">' +
            '<button type="button" class="bulk-modal__cancel" id="bulk-modal-cancel-btn">Vazgeç</button>' +
            '<button type="submit" class="bulk-modal__submit" id="bulk-modal-submit-btn">Gönder</button>' +
          '</div>' +
        '</form>' +
      '</div>';

    document.body.appendChild(overlay);

    function closeModal() {
      var el = document.getElementById('bulk-modal-overlay');
      if (el) el.remove();
    }

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.getElementById('bulk-modal-close').addEventListener('click', closeModal);
    document.getElementById('bulk-modal-cancel-btn').addEventListener('click', closeModal);

    document.getElementById('bulk-contact-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var form  = e.target;
      var name  = form.querySelector('#bulk-name').value.trim();
      var email = form.querySelector('#bulk-email').value.trim();
      if (!name || !email) {
        var first = !name ? form.querySelector('#bulk-name') : form.querySelector('#bulk-email');
        first.focus();
        return;
      }

      var submitBtn = document.getElementById('bulk-modal-submit-btn');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Gönderiliyor…';

      var phone = form.querySelector('#bulk-phone').value.trim();
      var qty   = form.querySelector('#bulk-qty').value.trim();
      var note  = form.querySelector('#bulk-note').value.trim();

      var body = '200 kg üzeri sipariş talebi\n';
      if (phone) body += 'Telefon: ' + phone + '\n';
      if (qty)   body += 'İstenen miktar: ' + qty + ' kg\n';
      if (note)  body += '\nNot: ' + note;

      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '\u2713');
      fd.append('contact[name]',  name);
      fd.append('contact[email]', email);
      fd.append('contact[body]',  body);

      fetch('/contact#contact_form', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function () {
          var modal = document.querySelector('#bulk-modal-overlay .bulk-modal');
          if (modal) {
            modal.innerHTML =
              '<div class="bulk-modal__success">' +
                '<div class="bulk-modal__success-icon">\u2705</div>' +
                '<h3>Talebiniz alındı!</h3>' +
                '<p>Ekibimiz en kısa sürede sizinle iletişime geçecek.</p>' +
                '<button type="button" class="bulk-modal__submit" id="bulk-success-close">Tamam</button>' +
              '</div>';
            document.getElementById('bulk-success-close').addEventListener('click', closeModal);
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Gönder';
          showError('Form gönderilemedi. Lütfen tekrar deneyin.');
        });
    });
  }

  /* ── Start ─────────────────────────────────────────────────── */
  init();
})();
